const TaskRoutes = [
    {
      path: "/tasks",
      name: "Tasks",
      component: () => import("@/pages/tasks/TaskListPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'read', on: 'Task'
        }
      },
      children: [
        {
          path: "new",
          name: "NewTask",
          component: () => import("@/pages/tasks/NewTaskPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'create', on: 'Task'
            }
          }
        },
        {
          path: ":id",
          name: "ShowTask",
          component: () => import("@/pages/tasks/ShowTaskPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'read', on: 'Task'
            }
          }
        },
      ]
    },
  ]
  
  export default TaskRoutes